module.exports = __webpack_public_path__ + "static/media/29PerformancePhotos.43e1d099.jpeg";